import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'

import { DeleteConfirmFormContent } from 'src/components/delete-confirm-form/delete-confirm-form.component'
import { disconnectFormSchema } from 'src/common/validations'

interface IDeleteConfirmFormProps {
  handleSubmit: () => void | Promise<void>
  disabled?: boolean
}

export const DisconnectConfirmForm = ({ handleSubmit, disabled }: IDeleteConfirmFormProps) => {
  const [t] = useTranslation()

  return (
    <Formik
      initialValues={{ delete: '' }}
      onSubmit={handleSubmit}
      validationSchema={disconnectFormSchema}
      validateOnMount={!disabled}
    >
      <Form>
        <DeleteConfirmFormContent
          title={t('disconnect-confirm-title.v')}
          submitText={t('disconnect-button-text.v')}
          disabled={disabled}
        />
      </Form>
    </Formik>
  )
}
